export class IconConstants {
    public static students = 'face';
    public static tests = 'assignment';
    public static classes = 'supervised_user_circle';
    public static reports = 'data_usage';
    public static settings = 'settings';
    public static help = 'help_outline';
}
